import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d9a13b10&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9a13b10')) {
      api.createRecord('d9a13b10', component.options)
    } else {
      api.reload('d9a13b10', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d9a13b10&", function () {
      api.rerender('d9a13b10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Agency/index.vue"
export default component.exports